import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./../images/logo-white.png";
import LogoSmall from "./../images/app-icon.png";
import { getWithExpiry, setWithExpiry } from "../common";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import svIcon from './../images/flags/sv.png';
import enIcon from './../images/flags/en.png';
import { useCookies } from "react-cookie";

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [translation] = useTranslation("translations");

  const [cookies] = useCookies(["sc_user_lang"]);
  const [userLang, setUserLang] = useState('sv');

  const isAdmin = useSelector((state) => state?.userdata?.isAdmin);
  const userMemberships = useSelector(
    (state) => state?.userdata.allUserData.membership_slugs
  );
  
  const communityOn = useSelector(
    (state) => state?.userdata.allUserData?.user_meta?.community_on
  );

  const allUserData = useSelector(
    (state) => state?.userdata.allUserData
  );

  useEffect(() => {
    const isMenuOpen = getWithExpiry("sustainchange_menu_open");

    if (isMenuOpen && window.innerWidth > 1023) {
      if (isMenuOpen === "yes") {
        setMenuOpen(true);
        setIsMobile(false);
      } else {
        setMenuOpen(false);
        setIsMobile(true);
      }
    }

    if (window.innerWidth < 1024) {
      setMenuOpen(false);
      setIsMobile(true);
    }

    if ( cookies.sc_user_lang ) {
      setUserLang( cookies.sc_user_lang );
    }
  }, [cookies.sc_user_lang]);

  const handleNavMenu = () => {
    if (menuOpen === true) {
      setMenuOpen(false);
      setWithExpiry("sustainchange_menu_open", "no");
    } else {
      setMenuOpen(true);
      setWithExpiry("sustainchange_menu_open", "yes");
    }
  };

  return (
    <div
      className={`navigation-wrap position-fixed top-0 h-100 ${
        menuOpen ? "nav-opened" : "nav-closed"
      }`}
    >
      <div
        className={`vertical-nav-wrap bg-halite-blue h-100 d-flex ${
          menuOpen ? "" : "closed"
        }`}
        style={{ width: "250px" }}
      >
        <div className="vertical-nav min-vh-100 h-100 w-100 d-flex flex-column pb-4">
          <div className="site-logo pt-3 ps-3">
            <Link to="/">
              <img
                src={Logo}
                alt="Sustain Change"
                className="img-fluid"
                style={{ maxWidth: "200px" }}
              />
            </Link>
          </div>

          {userMemberships && (
            <nav className="nav flex-column mt-5 mb-3">
              <Link
                to="/"
                className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                  window.location.pathname === "/" ? "active" : null
                }`}
              >
                <span className="font-size-medium text-uppercase">
                {translation('dashboard')}
                </span>
              </Link>
              <Link
                to="/change-boards/"
                className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                  window.location.pathname === "/change-boards/" ? "active" : null
                }`}
              >
                <span className="font-size-medium text-uppercase">
                 Change boards
                </span>
              </Link>
              

              <Link
                to="/my-tasks/"
                className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                  window.location.pathname === "/my-tasks/" ? "active" : null
                }`}
              >
                <span className="font-size-medium text-uppercase">
                {translation("my_planings")}
                </span>
              </Link>

              {allUserData?.all_capabilities && allUserData?.all_capabilities.includes('batteri') &&
                <Link
                  to="/my-battery/"
                  className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                    window.location.pathname === "/my-battery/" ? "active" : null
                  }`}
                >
                  <span className="font-size-medium text-uppercase">
                    {translation("battery_levels")}
                  </span>
                </Link>
              }
              

              {isAdmin && (
                <Link
                  to="/sustain-admin/"
                  className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                    window.location.pathname === "/sustain-admin/"
                      ? "active"
                      : null
                  }`}
                >
                  <span className="font-size-medium text-uppercase">
                    Sustain Admin
                  </span>
                </Link>
              )}
            </nav>
          )}
          {allUserData?.all_capabilities && allUserData?.all_capabilities.includes('artiklar_ftg') && (
            <div className="intructions-wrap">
              <span className="text-uppercase text-white placeholder-text font-size-medium ps-3 d-inline-block w-100">
                <span className="">{translation("kunsk_insp")}</span>
              </span>
              <nav className="nav flex-column mt-1">
                <Link
                  to="/kunskap-inspiration/forandra-ditt-liv/"
                  className={`nav-link text-white placeholder-text d-flex align-items-center py-0 ps-4 mt-1 ${
                    window.location.pathname ===
                    "/kunskap-inspiration/forandra-ditt-liv/"
                      ? "active"
                      : null
                  }`}
                >
                  <i className="fa fa-circle" aria-hidden="true"></i>
                  <span className="ms-2 font-size-medium">
                  {translation("change_life")}
                  </span>
                </Link>
                <Link
                  to="/kunskap-inspiration/forandra-pa-foretaget/"
                  className={`nav-link text-white placeholder-text d-flex align-items-center py-0 ps-4 mt-1 ${
                    window.location.pathname ===
                    "/kunskap-inspiration/forandra-pa-foretaget/"
                      ? "active"
                      : null
                  }`}
                >
                  <i className="fa fa-circle" aria-hidden="true"></i>
                  <span className="ms-2 font-size-medium">
                  {translation("change_company")}
                  </span>
                </Link>
              </nav>
            </div>
          )}

          <nav className="nav flex-column mt-1 mb-3">
            {userMemberships && (
              <>
              {allUserData?.all_capabilities && allUserData?.all_capabilities.includes('digitala_förelasningar') && (
                <Link
                  to="/digitala-traffar/"
                  className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                    window.location.pathname === "/digitala-traffar/"
                      ? "active"
                      : null
                  }`}
                >
                  <span className="font-size-medium text-uppercase">
                  {translation("digital_meetings")}
                  </span>
                </Link>
              )}

                { communityOn && communityOn === 'yes' &&
                  <Link
                    to="/community/"
                    className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                      window.location.pathname === "/community/" ? "active" : null
                    }`}
                  >
                    <span className="font-size-medium text-uppercase">
                    {translation('community_text')}
                    </span>
                  </Link>
                }
              </>
            )}

            {allUserData?.all_capabilities && allUserData?.all_capabilities.includes('artiklar_individ') && ! allUserData?.all_capabilities.includes('artiklar_ftg') && (
              <Link
                to="/kunskap-inspiration/forandra-ditt-liv/"
                className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                  window.location.pathname ===
                  "/kunskap-inspiration/forandra-ditt-liv/"
                    ? "active"
                    : null
                }`}
              >
                <span className="font-size-medium text-uppercase">
                {translation("kunsk_insp")}
                </span>
              </Link>
            )}
          </nav>

          <nav className="nav flex-column mt-4 mb-3">
            {userMemberships && (
              <>
                {allUserData?.all_capabilities && allUserData?.all_capabilities.includes('boka_konsult') &&
                  <Link
                  to="/boka-coach-konsult/"
                  className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                    window.location.pathname === "/boka-coach-konsult/"
                      ? "active"
                      : null
                  }`}
                >
                  <span className="font-size-medium text-uppercase">
                  {translation("book_coach")}
                  </span>
                </Link>
                }
                
                {allUserData?.all_capabilities && allUserData?.all_capabilities.includes('boka_vard') &&
                  <Link
                    to="/boka-vard/"
                    className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                      window.location.pathname === "/boka-vard/" ? "active" : null
                    }`}
                  >
                    <span className="font-size-medium text-uppercase">
                    {translation("book_care")}
                    </span>
                  </Link>
                }
                
                {allUserData?.all_capabilities && allUserData?.all_capabilities.includes('sjuk_frisk') &&
                  <Link
                  to="/sjuk-frisk/"
                  className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                    window.location.pathname === "/sjuk-frisk/"
                      ? "active"
                      : null
                  }`}
                >
                  <span className="font-size-medium text-uppercase">
                  {translation("sick_health")}
                  </span>
                </Link>
                }
                
              </>
            )}

            <Link
              to="/contact/"
              className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                window.location.pathname === "/contact/" ? "active" : null
              }`}
            >
              <span className="font-size-medium text-uppercase">
              {translation("contact_us")}
              </span>
            </Link>

            {!userMemberships && (
              <>
                <a
                  href="https://sustainchange.se/"
                  className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1`}
                >
                  <span className="font-size-medium text-uppercase">
                  {translation("to_homepage")}
                  </span>
                </a>

                {(window.location.pathname !== "/contact/" || window.location.pathname === "/plans/") &&
                  <Link to="/login/?logout=true" className="text-white placeholder-text text-decoration-none d-flex align-items-center py-1 ps-3 mt-1">{translation("log_out")}</Link>
                }

              </>
            )}
          </nav>

          {userMemberships && (
            <nav className="nav flex-column mt-4">
              <Link
                to="/anvandarguide"
                className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                  window.location.pathname ===
                  "/anvandarguide"
                    ? "active"
                    : null
                }`}
              >
                <span className="font-size-medium text-uppercase">
                  Användarguide
                </span>
              </Link>
              </nav>
            )}

          {userMemberships && userMemberships.includes("partner") && (
            <nav className="nav flex-column mt-4">
              <Link
                to="/partner-portal"
                className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                  window.location.pathname ===
                  "/partner-portal"
                    ? "active"
                    : null
                }`}
              >
                <span className="font-size-medium text-uppercase">
                {translation("partner_portal")}
                </span>
              </Link>
              </nav>
            )}
          
          {allUserData?.all_capabilities && allUserData?.all_capabilities.includes('lararhandledning') && (
            <nav className="nav flex-column">
              <Link
                to="/lararhandledning"
                className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                  window.location.pathname ===
                  "/lararhandledning"
                    ? "active"
                    : null
                }`}
              >
                <span className="font-size-medium text-uppercase">
                {translation("teacher_guide")}
                </span>
              </Link>
              </nav>
            )}

          {allUserData?.all_capabilities && allUserData?.all_capabilities.includes('lararhandledning_f3') && (
            <nav className="nav flex-column mb-3">
              <Link
                to="/lararhandledning-f-3"
                className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                  window.location.pathname ===
                  "/lararhandledning-f-3"
                    ? "active"
                    : null
                }`}
              >
                <span className="font-size-medium text-uppercase">
                {translation("teacher_guide")} F-3
                </span>
              </Link>
              </nav>
            )}

          {/* {userMemberships && (
            <nav className="nav flex-column mt-4">
              <Link
                  to="/piecharts/"
                  className={`nav-link text-white placeholder-text d-flex align-items-center py-1 mt-1 ${
                    window.location.pathname === "/piecharts/"
                      ? "active"
                      : null
                  }`}
                >
                  <span className="font-size-medium text-uppercase">
                  Pie Charts
                  </span>
                </Link>
              </nav>
            )} */}

            {isMobile &&
              <div className="intructions-wrap">
                <span className="text-uppercase text-white placeholder-text font-size-medium ps-3 d-inline-block w-100">
                  <span className="">{translation("settings")}</span>
                </span>
                <nav className="nav flex-column mt-1 mb-3">
                  {isAdmin &&
                    <Link
                    to="/organizations"
                    className={`nav-link text-white placeholder-text d-flex align-items-center py-0 ps-4 mt-1 ${
                      window.location.pathname ===
                      "/organizations"
                        ? "active"
                        : null
                    }`}
                  >
                    <i className="fa fa-circle" aria-hidden="true"></i>
                    <span className="font-size-medium ms-2">
                    {translation("organisations")}
                    </span>
                  </Link>
                  }

                  { allUserData?.organization && allUserData?.org_name && allUserData?.org_name?.length > 0 &&
                    <Link
                    to={`/organizations/${allUserData?.organization}`}
                    className={`nav-link text-white placeholder-text d-flex align-items-center py-0 ps-4 mt-1 ${
                      window.location.pathname ===
                      `/organizations/${allUserData?.organization}`
                        ? "active"
                        : null
                    }`}
                  >
                    <i className="fa fa-circle" aria-hidden="true"></i>
                    <span className="font-size-medium ms-2">
                    {allUserData?.org_name}
                    </span>
                  </Link>
                  }
                </nav>
              </div>
            }
        </div>
      </div>

      <div
        className={`nav-icon-wrap position-absolute ${
          menuOpen ? "open" : "closed"
        }`}
        onClick={() => handleNavMenu()}
      >
        <div className="nav-icon-bars d-flex flex-column">
          <span className={`bar bar-1 w-100 mb-1`}></span>
          <span className={`bar bar-2 mb-1`}></span>
          <span className={`bar bar-3 mb-1`}></span>
        </div>
      </div>

      {!menuOpen && (
        <div className="horizontal-nav-wrap bg-halite-blue position-absolute top-0 d-flex align-items-center align-items-lg-start justify-content-end pe-3 pe-lg-3">
          <div className="horizontal-nav-inner d-flex flex-lg-column align-items-center justify-content-center ps-4 ps-lg-0">
            <div className="horizontal-nav-item small-logo-wrap ps-5 ps-lg-0">
              <Link
                to="/"
                className={`text-white d-flex align-items-center py-1 mt-lg-2 text-decoration-none`}
              >
                <img
                  src={LogoSmall}
                  alt="SustainYou"
                  className="img-fluid rounded-circle"
                  style={{ maxWidth: "25px" }}
                />
              </Link>
            </div>
            <div className="horizontal-nav-item mt-lg-4 mb-lg-3 ms-4 ms-lg-0">
              <Link
                to="/"
                className={`text-white placeholder-text d-flex align-items-center text-decoration-none py-1 mt-1 ${
                  window.location.pathname === "/" ? "active" : null
                }`}
              >
                <i className="fa fa-tachometer fa-lg" aria-hidden="true"></i>
              </Link>
            </div>
            <div className="horizontal-nav-item mb-lg-3 ms-4 ms-lg-0">
              <Link
                to="/settings/"
                className={`text-white placeholder-text d-flex text-decoration-none align-items-center py-1 mt-1 ${
                  window.location.pathname === "/settings/" ? "active" : null
                }`}
              >
                <i className="fa fa-cogs fa-lg" aria-hidden="true"></i>
              </Link>
            </div>
            <div className="horizontal-nav-item mb-lg-3 ms-4 ms-lg-0">
              <Link
                to="/login/?logout=true"
                className="text-white placeholder-text text-decoration-none d-flex align-items-center py-1 mt-1"
              >
                <i className="fa fa-sign-out fa-lg" aria-hidden="true"></i>
              </Link>
            </div>
            <div className="horizontal-nav-item mb-lg-3 ms-4 ms-lg-0">
              <a
                href={`${window.location.pathname}?lang=${userLang === 'en' ? 'sv' : 'en'}`}
                className="text-white placeholder-text text-decoration-none d-flex align-items-center py-1 mt-1"
              >
                <img src={userLang === 'en' ? svIcon : enIcon} alt="Svenska" className="rounded-circle" style={{width:'21px',height: '21px'}} />
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navigation;
